import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import {
  applicationDocsKey,
  formDeleteDocumentRoute,
} from '@features/applicationsDocs';
import axiosInstance from '@server/axiosInstance';

type UseDeleteApplicationDocsProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  applicationId: number;
};

export const useDeleteApplicationDocs = ({
  setErrorText,
  applicationId,
}: UseDeleteApplicationDocsProps) => {
  const client = useQueryClient();

  const { mutate: deleteDocument, isLoading: isDeletingApplicationDocument } =
    useMutation({
      mutationFn: (variables: { documentId: number }) =>
        axiosInstance
          .post(formDeleteDocumentRoute(variables.documentId))
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([applicationDocsKey, applicationId]);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    deleteDocument,
    isDeletingApplicationDocument,
  };
};
